import SageScreen from "kit/SageScreen";
import React from "react";
import LoginBody from "./LoginBody";
import styles from "./Login.module.scss";
import { Link } from "react-router-dom";

const Login: React.FC = () => {
    return (
        <SageScreen>
            <h1>Login</h1>
            <LoginBody />
            <div className={styles.linkContainer}>
                <Link className={styles.link} to="/welcome/sign-up">
                    Don&apos;t have an account yet? Create one
                </Link>
            </div>
        </SageScreen>
    );
};

export default Login;
